import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { SocketProvider } from "./context/SocketContext";
import { AudioSettingsProvider } from "./context/AudioSettingsContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";

import Home from "./pages/Home";
import Comentarios from "./pages/Comentarios";
import Directo from "./pages/Directo";
import Usuarios from "./pages/Usuarios";
import Datos from "./pages/Datos";
import Tv from "./pages/Tv";
import Cajas from "./pages/Cajas";
import Config from "./pages/Config";
import Login from "./pages/Login";
import Overlay from "./pages/Overlay";
import SoundOverlay from "./pages/SoundOverlay";

function ProtectedApp({ children }) {
  return (
    <ProtectedRoute>
      <SocketProvider>
        <AudioSettingsProvider>
          <AppShell>{children}</AppShell>
        </AudioSettingsProvider>
      </SocketProvider>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedApp><Home /></ProtectedApp>} />
          <Route path="/comentarios" element={<ProtectedApp><Comentarios /></ProtectedApp>} />
          <Route path="/usuarios" element={<ProtectedApp><Usuarios /></ProtectedApp>} />
          <Route path="/directo" element={<ProtectedApp><Directo /></ProtectedApp>} />
          <Route path="/datos" element={<ProtectedApp><Datos /></ProtectedApp>} />
          <Route path="/tv" element={<ProtectedApp><Tv /></ProtectedApp>} />
          <Route path="/cajas" element={<ProtectedApp><Cajas /></ProtectedApp>} />
          <Route path="/config" element={<ProtectedApp><Config /></ProtectedApp>} />
          <Route path="/overlay" element={<Overlay />} />
          <Route path="/sonido" element={<SoundOverlay />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
